import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';

const initialState = {
	all: null,
};

const campaignsSlice = createSlice({
	name: 'campaigns',
	initialState,
	reducers: {
		setCampaigns: (state, action) => {
			if (action.payload) {
				state.all = action.payload.campaigns;
			}
		},
		resetCampaigns: (state) => {
			state.all = initialState.all;
		},
	},
});

export default campaignsSlice.reducer;
export const { setCampaigns, resetCampaigns } = campaignsSlice.actions;

export const selectAllCampaigns = (state) => state.campaigns.all;
export const selectCampaignById = (state, campaignId) => state.campaigns.all?.find((el) => el.id === campaignId);
export const selectCampaignsByIds = (state, campaignIds) => {
	if (!campaignIds) {
		return null;
	}

	const campaigns = state.campaigns.all?.filter((el) => campaignIds.includes(el.id));
	return keyBy(campaigns, 'id');
};
